<template>
  <div class="exhibition">
    <common-layout>
      <div slot="header">
        <h3>合作机构</h3>
      </div>
      <div slot="container">
        <div class="exhibition.header">
          <div class="exhibition-search">
            <el-button
              type="success"
              icon="el-icon-plus"
              @click="add"
              style="background: #623aa2; border: none"
            >
              新增
            </el-button>
            <el-button type="danger" icon="el-icon-delete" @click="deleteAll">批量删除</el-button>

            <label>机构类型</label>
            <el-select
              style="width:140px"
              v-model="paramsObj.type"
              clearable
              placeholder="全部"
              @change="search"
            >
              <el-option
                v-for="item in typeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="exhibition-table">
          <el-table
            ref="multipleTable"
            :data="tableData"
            style="width: 100%"
            :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }"
            class="table"
            @selection-change="selectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column type="index" width="150" label="序号" align="center">
              <template slot-scope="scope">
                <span>
                  {{ scope.$index + (paramsObj.page - 1) * paramsObj.pageSize + 1 }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="机构名称" align="center" prop="name"></el-table-column>
            <el-table-column label="机构logo" align="center" prop="logo">
              <template slot-scope="scope">
                <div slot="reference" class="name-wrapper">
                  <img style="height: 50px;" :src="scope.row.logoSrc[0].url" />
                </div>
              </template>
            </el-table-column>
            <el-table-column label="机构简介" align="center" prop="introduction">
              <template slot-scope="scope">
                {{ getContent(scope.row.introduction) }}
              </template>
            </el-table-column>
            <el-table-column label="机构类型" align="center" prop="type">
              <template slot-scope="scope">
                <div slot="reference" v-show="scope.row.type === 1">科研院所</div>
                <div slot="reference" v-show="scope.row.type === 2">高等院校</div>
                <div slot="reference" v-show="scope.row.type === 3">企业</div>
                <div slot="reference" v-show="scope.row.type === 4">科技服务中心</div>
                <div slot="reference" v-show="scope.row.type === 5">金融机构</div>
              </template>
            </el-table-column>
            <el-table-column label="经营范围" align="center" prop="">
              <template slot-scope="scope">
                {{ getContent(scope.row.businessScope) }}
              </template>
            </el-table-column>
            <el-table-column label="发布时间" align="center" prop="publishedTime"></el-table-column>
            <el-table-column align="center" label="操作">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="success"
                  @click="release(scope.row, 1)"
                  v-if="scope.row.publishedFlag == 0"
                >
                  确认发布
                </el-button>
                <el-button size="mini" type="warning" @click="release(scope.row, 2)" v-else>
                  取消发布
                </el-button>
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="primary"
                  @click="handleEdit(scope.$index, scope.row)"
                >
                  编辑
                </el-button>
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.$index, scope.row)"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="paramsObj.page"
          :page-size="paramsObj.pageSize"
          layout="total,prev, pager, next"
          :total="total"
          style="text-align: left; margin: 20px 0"
        ></el-pagination>
      </div>
    </common-layout>
    <el-dialog
      :title="Title"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      @closed="is_submit = true"
    >
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        :rules="rules"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="机构名称" prop="name">
          <el-input
            v-model="ruleForm.name"
            placeholder="请输入机构名称"
            :disabled="isDetail"
          ></el-input>
        </el-form-item>
        <el-form-item label="机构类型" prop="type">
          <el-select
            v-model="ruleForm.type"
            placeholder="请选择机构类型"
            clearable
            :disabled="isDetail"
          >
            <el-option
              :label="item.label"
              :value="item.value"
              v-for="item in typeList"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="机构logo" prop="logo">
          <el-upload
            class="avatar-uploader"
            :action="this.uploadURL"
            list-type="picture-card"
            name="file"
            :file-list="logo"
            :before-upload="beforeAvatarUpload"
            :disabled="isDetail"
            :limit="limit"
            ref="upload0"
            :on-success="
              (response, file, fileList) => handleAvatarSuccess(response, file, fileList, 'logo')
            "
          >
            <i slot="default" class="el-icon-plus"></i>
            <div slot="file" slot-scope="{ file }">
              <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
              <span class="el-upload-list__item-actions">
                <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                  <i class="el-icon-zoom-in"></i>
                </span>
                <span
                  v-if="!isDetail"
                  class="el-upload-list__item-delete"
                  @click="handleRemove(file, 'logo')"
                >
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
            <div slot="tip" class="el-upload__tip" v-if="showUpload && !isDetail">
              只允许上传一张图片
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="机构简介" prop="introduction">
          <el-input
            type="textarea"
            v-model="ruleForm.introduction"
            placeholder="请输入机构简介"
            :disabled="isDetail"
          ></el-input>
        </el-form-item>
        <el-form-item label="经营范围" prop="businessScope">
          <el-input
            type="textarea"
            v-model="ruleForm.businessScope"
            placeholder="请输入经营范围"
            :disabled="isDetail"
          ></el-input>
        </el-form-item>
        <el-form-item label="发布时间" prop="publishedTime">
          <el-date-picker
            v-model="ruleForm.publishedTime"
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="请选择发布时间"
            style="text-align: left; width: 100%"
            :disabled="isDetail"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="是否发布" prop="publishedFlag" style="text-align:left">
          <el-switch
            v-model="ruleForm.publishedFlag"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-text="是"
            inactive-text="否"
            :active-value="1"
            :inactive-value="0"
            :disabled="isDetail"
          ></el-switch>
        </el-form-item>
        <div style="text-align: right; margin-top: 10px">
          <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
          <el-button @click="closeForm('ruleForm')" v-if="!isDetail">取消</el-button>
          <el-button @click="closeForm('ruleForm')" v-if="isDetail">关闭</el-button>
        </div>
      </el-form>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import CommonLayout from '../../../components/common-layout.vue';
import { DisabledDateFn } from '../../../utils/tool';
export default {
  components: { CommonLayout },
  data() {
    return {
      listUrl: `${urlConfig.devUrl}apij2/admin-api/trade/institutions/page`,
      logo: [],
      total: 10,
      pickerOptions: {
        disabledDate: this.disabledDateFn
      },
      paramsObj: {
        page: 1,
        pageSize: 10,
        type: ''
      },
      typeList: [
        // { value: 0, label: "全部" },
        { value: 1, label: '科研院所' },
        { value: 5, label: '金融机构' },
        { value: 2, label: '高等院校' },
        { value: 3, label: '企业' },
        { value: 4, label: '科技服务中心' }
      ],
      limit: 1,
      showUpload: false,
      is_submit: true,
      Title: '',
      dialogFormVisible: false,
      searchValue: '',
      deleteRow: [],
      tableData: [],
      ruleForm: {
        name: '',
        type: 0,
        publishedTime: '',
        publishedFlag: 0,
        logo: ''
      },
      rules: {
        name: [{ required: true, message: '请输入机构名称', trigger: 'blur' }],
        type: [{ required: true, message: '请选择机构类型', trigger: ['blur', 'change'] }],
        publishedTime: [
          {
            type: 'string',
            required: true,
            message: '请选择发布时间',
            trigger: 'change'
          }
        ],
        logo: [{ required: true, message: '请上传机构logo', trigger: ['blur', 'change'] }]
      },
      isDetail: false,
      dialogImageUrl: '',
      dialogVisible: false
    };
  },
  created() {
    this.getData();
    console.log(this.$refs.upload0);
  },
  watch: {
    // 监听初始时图片列表长度, 与limit相等则隐藏按钮
    logo: {
      handler(val) {
        console.log(val);
        this.checkLimit(this.logo, 0);
      }
    }
  },
  methods: {
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    checkLimit(filelist, index) {
      const limit = this.limit;
      console.log(this.$refs);
      this.$nextTick(() => {
        const uploadDom = this.$refs['upload' + index];
        console.log(uploadDom);
        if (filelist.length === limit) {
          uploadDom.$children[1].$el.style.display = 'none';
          this.showUpload = true;
        } else {
          uploadDom.$children[1].$el.style.display = '';
          this.showUpload = false;
        }
      });
    },
    handleAvatarSuccess(response, file, fileList, type) {
      if (response.code == 0) {
        this[type] = fileList;
        console.log(this.ruleForm.logo);
        this.fileListChange(type);
      }
    },
    fileListChange(type) {
      let arr = [];
      if (this[type].length > 0) {
        this[type].map(item => {
          arr.push({
            url: item.size ? this.imgUrl + item.response.data.store_result : item.url,
            name: item.name
          });
        });
        this.ruleForm[type] = JSON.stringify(arr);

        // if (type === 'logo' || type === 'realImageSrc') {
        //   this.ruleForm[type] = arr[0].url;
        // }
      } else {
        this.ruleForm[type] = '';
        this[type] = [];
      }
    },
    beforeAvatarUpload(file) {
      let type = false;
      if (
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/jpg' ||
        file.type === 'image/gif' ||
        file.type === 'image/bmp'
      ) {
        type = true;
      }

      var img = new Image();
      img.src = this.image;
      img.onload = function() {};

      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!type) {
        this.$message.error('上传图片只能是 JPEG/jpg/png/gif/bmp 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 10MB!');
      }
      return type && isLt2M;
    },
    //禁用时间选择
    disabledDateFn(time) {
      return DisabledDateFn(time);
    },
    getData() {
      this.http.post(this.listUrl, this.paramsObj).then(res => {
        if (res.code == 0) {
          let arr = res.data.data;
          arr.forEach(item => {
            if (item.logo) {
              item.logoSrc = JSON.parse(item.logo);
            } else {
              item.logoSrc = [];
            }
          });
          this.tableData = arr;
          this.total = res.data.total;
        }
      });
    },
    //新增
    add() {
      this.is_submit = true;

      this.dialogFormVisible = true;
      this.Title = '新增机构';
      this.ruleForm = {
        name: '',
        logo: '',
        type: '',
        publishedFlag: 0,
        publishedTime: ''
      };
      this.logo = [];
      this.$refs.ruleForm.resetFields();
    },
    //编辑
    handleEdit(index, row) {
      this.is_submit = true;

      this.logo = [];
      this.dialogFormVisible = true;
      console.log(this.$refs.upload0);
      this.Title = '编辑机构';
      this.ruleForm = JSON.parse(JSON.stringify(row));
      if (row.logo) {
        this.logo = JSON.parse(this.ruleForm.logo);
      } else {
        this.logo = [];
      }
      console.log(this.logo);
    },
    //提交
    submitForm(name) {
      if (!this.is_submit) {
        return false;
      }
      this.is_submit = false;
      this.$refs[name].validate(valid => {
        if (valid) {
          let obj = JSON.parse(JSON.stringify(this.ruleForm));
          if (!obj?.id) {
            this.http
              .post(`${urlConfig.devUrl}apij2/admin-api/trade/institutions/create`, obj)
              .then(res => {
                if (res.code == 0) {
                  this.$message.success('新建成功');
                  this.getData();
                  this.logo = [];
                  this.dialogFormVisible = false;
                  this.$refs[name].resetFields();
                } else {
                  this.is_submit = true;
                }
              })
              .catch(err => {
                this.is_submit = true;
              });
          }
          if (this.Title == '编辑机构') {
            this.http
              .post(`${urlConfig.devUrl}apij2/admin-api/trade/institutions/update`, obj)
              .then(res => {
                if (res.code == 0) {
                  this.$message.success('编辑成功');
                  this.getData();
                  this.logo = [];
                  this.dialogFormVisible = false;
                  this.$refs[name].resetFields();
                } else {
                  this.is_submit = true;
                }
              })
              .catch(err => {
                this.is_submit = true;
              });
          }
        } else {
          this.is_submit = true;

          return false;
        }
      });
    },
    //取消
    closeForm(name) {
      this.dialogFormVisible = false;
      this.$refs[name].resetFields();
      this.logo = [];
    },
    //发布
    release(e) {
      this.$confirm(e.publishedFlag == 0 ? '确定发布吗?' : '确定取消发布吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then(() => {
          this.operateRelease(e);
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: e.publishedFlag == 0 ? '取消确认发布' : '取消发布'
          });
        });
    },
    operateRelease(e) {
      let data = e;
      if (e.publishedFlag == 0) {
        data.publishedFlag = 1;
      } else if (e.publishedFlag == 1) {
        data.publishedFlag = 0;
      }
      this.http
        .post(`${urlConfig.devUrl}apij2/admin-api/trade/institutions/update`, data)
        .then(res => {
          if (res.code == 0) {
            if (data.publishedFlag == 1) {
              this.$message.success('发布成功');
            } else {
              this.$message.success('已取消发布');
            }
            this.getData();
          } else {
            this.$message.error(res.status);
          }
        });
    },
    //搜索
    search() {
      this.getData();
    },
    //选择
    selectionChange(selection) {
      this.deleteRow = [];
      if (selection.length != 0) {
        let arr = [];
        selection.forEach(item => {
          arr.push(item.id);
        });
        this.deleteRow = arr;
      }
    },
    //删除
    handleDelete(index, row) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then(() => {
          this.http
            .delete(`${urlConfig.devUrl}apij2/admin-api/trade/institutions/delete?id=${row.id}`)
            .then(res => {
              if (res.code == 0) {
                this.paramsObj.page = 1;
                this.getData();
                this.$message({
                  type: 'success',
                  message: '删除成功'
                });
              } else {
                this.$message({
                  message: '失败！',
                  type: 'error'
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    //批量删除
    deleteAll() {
      if (this.deleteRow.length > 0) {
        this.$confirm('此操作将批量删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        })
          .then(() => {
            let obj = {
              ids: this.deleteRow
            };
            this.http
              .post(`${urlConfig.devUrl}apij2/admin-api/trade/institutions/deletes`, obj)
              .then(res => {
                if (res.code == 0) {
                  this.paramsObj.page = 1;
                  this.getData();
                  this.$message({
                    type: 'success',
                    message: '删除成功'
                  });
                } else {
                  this.$message({
                    message: '失败！',
                    type: 'error'
                  });
                }
              });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
      } else {
        this.$message({
          type: 'warning',
          message: '请选择删除的机构'
        });
      }
    },
    //翻页
    handleCurrentChange(val) {
      this.getData();
    },
    handleRemove(file, type) {
      this.$confirm('确定删除图片吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then(() => {
          for (var i = 0; i < this[type].length; i++) {
            if (file.uid == this[type][i].uid) {
              this[type].splice(i, 1);
            }
          }
          console.log(this[type]);
          this.fileListChange(type);

          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    getContent(text) {
      if (text && text.length > 10) {
        return text.substring(0, 10) + '...';
      }
      return text;
    }
  }
};
</script>
<style lang="scss" scoped>
@include component(exhibition) {
  width: 100%;
  height: 100%;
  /deep/.el-tag {
    &:hover {
      cursor: pointer;
    }
  }
  .exhibition-search {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    .el-input {
      width: 400px;
      margin: 0 15px;
    }
    label {
      line-height: 40px;
      margin: 0 10px 0 30px;
    }
  }
  .exhibition-table {
    width: 100%;
    margin-top: 20px;
    border: 1px solid #eef1f6;
  }
  /*上传图片*/
  .is_border {
    border: 1px dashed #ddd !important;
    border-radius: 5px;
    height: 154px !important;
    line-height: 154px !important;
  }

  .upload_btn {
    display: block;
    background-color: #00a1ff;
    font-weight: bold;
    color: #fff;
    padding: 2px;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }

  .upload_btn:hover {
    background-color: #13ce66;
  }

  .del_img {
    position: absolute;
    top: -7px;
    left: 224px;
    color: #00a1ff;
  }

  .del_img:hover {
    cursor: pointer;
    color: #f00;
  }

  .del_img i:before {
    font-size: 20px;
  }

  .img_border {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    width: 243px;
    height: 154px;
    display: block;
  }

  .avatar-uploader {
    text-align: left;
    width: 243px;
    height: 200px;
  }

  /deep/ .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  /deep/ .el-upload:hover {
    border-color: #409eff !important;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 243px;
    height: 154px;
    line-height: 154px;
    text-align: center;
  }

  .demo-ruleForm {
    .el-select {
      width: 100%;
    }
  }
}
</style>
